import React from 'react';
import classnames from 'classnames';
import _ from 'lodash';

import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux'
import store from '../../Redux';
import { doPost, doLoad, doPut, select, doDelete } from '../../Redux/Actions'

import AddIcon from '@material-ui/icons/Add';

import { TextFieldHelper, SelectFieldWrapper } from '../../Components/Fields';
import Table from '../../Components/Table';
import Loader from '../../Components/Loader';
import Master from '../../Components/Master';

import Button from '@material-ui/core/Button';
import Dialog from '../../Components/Dialog';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';

import moment from 'moment'

const ENDPOINT = "fuhrpark"

const styles = theme => ({
    fab: {
       position: 'absolute',
       bottom: theme.spacing.unit * 2,
       right: theme.spacing.unit * 2,
    },
})

const columns = [
    "Matchcode",
    "Kennzeichen",
    "Marke",
    "Handelsbez.",
    "erst. Zulassung",
    "Alter",
    "Sitzplatz",
    "Stehplatz",
];
const options = {}

var FuhrparkDialogFields = ({handleChange, data}) => {
    return (
        <div>
            <Grid container spacing={8}>
                <TextFieldHelper n={12} value={data.match} onChange={handleChange('match')} label="Matchcode" />
                <TextFieldHelper n={6} value={data.marke} onChange={handleChange('marke')} label="Marke" />
                <TextFieldHelper n={6} value={data.kennzeichen} onChange={handleChange('kennzeichen')} label="Kennzeichen" />
                <TextFieldHelper n={12} multiline rowsMax={4} value={data.notiz} onChange={handleChange('notiz')} label="Notiz" />
            </Grid>
        </div>
    )
}

class Fuhrpark extends Master {

    state = {
        fuhrpark: {},
        putLoading: {},
        tabs: 0,
        dialogOpen: false,
        newEntry: {

        },
        tableFilter: {

        }
    }

    componentDidMount() {
        document.title = "Fuhrpark"
        this.props.doLoad()
    }

    componentWillMount() {
        this.unsubscribe = store.subscribe(() => {
                var genericData = select(store.getState(), "fuhrpark")
                if(_.has(genericData, "putLoading") && this.state.putLoading !== genericData.putLoading) {
                    this.setState({
                        putLoading: genericData.putLoading
                    })
                }
                if(_.has(genericData, "dialogOpen") && this.state.dialogOpen !== genericData.dialogOpen) {
                    this.setState({
                        dialogOpen: genericData.dialogOpen
                    })
                }
            }
        )
    }

    componentWillUnmount() {
        this.unsubscribe()
    }

    handleClickOpen = () => {
        this.setState({
            dialogOpen: this.state.dialogOpen ? false : true
        });
    }

    postData = () => {
        this.props.doPost(this.state.newEntry)
        this.setState({
            newEntry: {}
        })
    }

    handleChange = name => event => {
        this.state.newEntry[name] = event.target.value
        this.setState({
            newEntry: this.state.newEntry
        });
    }

    populate = (data) => {
        this.props.doLoad(data)
    }

    deleteAction = (id) => {
        if (window.confirm('Willst du den Eintrag wirklich löschen?')) {
            this.props.doDelete(id)
        }
    }

    gotoToDetail = (rowIndex, data) => {
        this.props.history.push("fuhrpark/"+this.props.fuhrpark.data[rowIndex].id)
    }

    render() {

        var {
            classes
        } = this.props

        var {
            dialogOpen, isLoading
        } = this.state

        if(isLoading) {
            return (
                <Loader />
            )
        }

        var items = []
        if(_.has(this.props, 'fuhrpark.data') && this.props.fuhrpark.data.length > 0) {
            this.props.fuhrpark.data.forEach((item) => {
                items.push([
                    item.match === undefined ? "-" : item.match,
                    item.kennzeichen === undefined ? "-" : item.kennzeichen,
                    item.marke === undefined ? "-" : item.marke,
                    item.handelsbezeichnung_kurz === undefined ? "-" : item.handelsbezeichnung_kurz,
                    item.erstmalige_zugelassung === undefined ? "-" : moment(item.erstmalige_zugelassung).format("L"),
                    item.erstmalige_zugelassung === undefined ? "-" : moment(new Date()).diff(item.erstmalige_zugelassung, 'years'),
                    item.sitzplaetze === undefined ? "-" : item.sitzplaetze,
                    item.stehplaetze === undefined ? "-" : item.stehplaetze,
                    item.id
                ])
            })
        }

        return (
            <div>

                <TextField
                    placeholder="Suchen"
                    type="search"
                    margin="normal"
                    fullWidth
                    autoFocus
                    onChange={this.search()}
                />

                <Table
                    title="Fuhrpark"
                    key={"items"+items.length}
                    data={items}
                    count={this.props.fuhrpark.count}
                    columns={columns}
                    populate={this.populate}
                    onDelete={this.deleteAction}
                    rowClick={this.gotoToDetail}
                    options={{
                        selectableRows: false
                    }}
                />

                <Button variant="fab" className={classes.fab} onClick={this.handleClickOpen} color={"primary"}>
                    <AddIcon />
                </Button>
                <Dialog
                    title="Neues Fahrzeug"
                    saveAction={this.postData}
                    closeAction={this.handleClickOpen}
                    open={dialogOpen}
                >
                    <FuhrparkDialogFields data={this.state.newEntry} handleChange={this.handleChange} />
                </Dialog>

            </div>
        )
    }

}

const mapStateToProps = state => ({
    fuhrpark: state.fuhrpark,
    /*
        generic: state.mitarbeiter,
        bankverbindungen: state.mitarbeiterBankverbindung,
        beschaeftigung: state.mitarbeiterBeschaeftigung,
    */
})

const mapDispatchToProps = (dispatch, ownProps) => ({

    doLoad: (filter) => dispatch(doLoad("fuhrpark", "api/generic/fuhrpark/list", filter)),
    doPost: (data) => dispatch(doPost("fuhrpark", "api/generic/fuhrpark", data)),
    doSearch: (filter) => dispatch(doLoad(ENDPOINT, "api/generic/"+ENDPOINT+"/list", filter)),

    doDelete: (id) => dispatch(doDelete("fuhrpark", "api/generic/fuhrpark/"+id, id)),
    /*


        doPut: (id, data) => dispatch(doPut("MITARBEITER", "api/generic/mitarbeiter/"+id, data)),

    */

})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(Fuhrpark));



// WEBPACK FOOTER //
// ./src/Routes/Fuhrpark/index.js